import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./relevantKinds.module.less";
import cx from "classnames";
import { Affix } from "antd";
import { fetchArticleRelatedKinds } from "@Services/article";
import { formatThousend } from "../../../utils/helper";
import { formatNumberToUnitString } from "@t8891/utils";

interface ArticleItem {
  brand_id: number;
  kind_id: number;
  brandId: number;
  kindId: number;
  name: string;
  brandName: string;
  myid: number;
  kindName: string;
  price: string;
  thumb: string;
  isInquiry: number;
  discountPrice: string;
  discountPriceForInt: number;
  inquiryNum: number;
  hasSuperTestReport: number;
  informationCount: number;
  menuCount: number;
  menuLink: string;
  visitsRank: string;
  commentCount: number;
  hasIm: number;
  btnStatus: number;
  nk: number;
  inStock: number;
  link?: string;
}

const RelevantKinds: React.FC = () => {
  const targetRef = useRef<HTMLDivElement>(null);
  const itemRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(true);
  const [articleData, setArticleData] = useState<ArticleItem[]>([]);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scroll(scrollLeft + scrollValue - 2, 0);
  }, []);

  const handleScroll = useCallback(() => {
    if (targetRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = targetRef.current;
      
      setRight(scrollLeft === clientWidth); // 添加10px的容差
      setLeft(scrollLeft===0);
    }
  }, []);

  const getData = async () => {
    try {
      const res: any = await fetchArticleRelatedKinds({
        articleId: window.article?.id || 0,
        limit: 20,
        type: window.article?.type || 1,
      });

      if (res?.status === 12000) {
        setArticleData([     {
          "brand_id": 43,
          "kind_id": 11302,
          "brandId": 43,
          "kindId": 11302,
          "name": "Subaru Outback",
          "brandName": "Subaru",
          "myid": 24728,
          "kindName": "Outback",
          "price": "162.8萬",
          "thumb": "https://p3.8891.com.tw/nc/2021/04/22/s/1619074062445116_300_200.png",
          "isInquiry": 1,
          "discountPrice": "",
          "discountPriceForInt": 0,
          "inquiryNum": 449,
          "hasSuperTestReport": 24729,
          "informationCount": 65,
          "menuCount": 13,
          "menuLink": "https://c.8891.com.tw/buy-car/menu?brandId=43&kindId=11302",
          "visitsRank": "Wagon旅行車第16名",
          "commentCount": 7,
          "hasIm": 0,
          "btnStatus": 2,
          "nk": 4322,
          "inStock": 1
      },
      {
          "brand_id": 43,
          "kind_id": 11302,
          "brandId": 43,
          "kindId": 11302,
          "name": "Subaru Outback",
          "brandName": "Subaru",
          "myid": 24728,
          "kindName": "Outback",
          "price": "162.8萬",
          "thumb": "https://p3.8891.com.tw/nc/2021/04/22/s/1619074062445116_300_200.png",
          "isInquiry": 1,
          "discountPrice": "",
          "discountPriceForInt": 0,
          "inquiryNum": 449,
          "hasSuperTestReport": 24729,
          "informationCount": 65,
          "menuCount": 13,
          "menuLink": "https://c.8891.com.tw/buy-car/menu?brandId=43&kindId=11302",
          "visitsRank": "Wagon旅行車第16名",
          "commentCount": 7,
          "hasIm": 0,
          "btnStatus": 2,
          "nk": 4322,
          "inStock": 1
      }]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!!articleData?.length && articleData?.length > 1) {
      setRight(false);
    }
  }, [articleData]);

  
  useEffect(() => {
    const scrollContainer = targetRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll, targetRef.current]);

 
  if (articleData.length === 0) {
    return null;
  }

  return (
    <Affix offsetTop={0}>
      <div className={cx(styles["relevant-kind"])}>
        <div className='flex justify-center items-center bg-[#fff] relative rounded-bl-6 rounded-br-6'>
          {!left && (
            <i
              className={styles["left-icon"]}
              onClick={(e) => {
                e.stopPropagation();

                scrollTo(-282);
              }}
            />
          )}
          {!right && (
            <i
              className={styles["right-icon"]}
              onClick={(e) => {
                e.stopPropagation();
                scrollTo(282);
              }}
            />
          )}
          <div className={styles["brand-scroll"]} ref={targetRef}>
            {Array.isArray(articleData) &&
              articleData.map((v: any, i) => (
                <div className={styles["item"]} key={i} ref={itemRef}>
                  <a
                    id='ArticleKindsLinkToSummary'
                    href={`/photoModel-info.html?k=${v.kindId}`}
                    target='_blank'
                    className={cx(styles["link"], {
                      'pointer-events-none': !v.link
                    })}
                  >
                    <img src={v.thumb} alt='' className={styles["img"]} />
                    <div className={styles["name"]}>{v.name}</div>
                    <div className={styles["bottom"]}>
                      <span className={styles["price"]}>{v.price}</span>
                      {!!v?.discountPrice && <span className={styles["discountPrice"]}>禮包{v.discountPrice}</span>}
                    </div>
                  </a>

                  <div className='h-90 pb-20 flex items-center flex-col justify-center'>
                    {v.isInquiry === 1 && (
                      <div className={styles["btn"]}>
                        <div
                          id='tracking-ask-price-installment'
                          data-id={window.article?.id}
                          data-type={window.article?.type || 1}
                        >
                          <a
                            id='ArticleKindsLinkToAskPriceInstallment'
                            href={`/ask/price?b=${v.brandId}&k=${v.kindId}&source=文章詳情頁-相關車款-分期購車&kindType=installment`}
                            target='_blank'
                            className={cx(styles["equips"], {
                              'pointer-events-none': !v.link
                            })}
                          >
                            分期購車
                          </a>
                        </div>

                        <div id='tracking-ask-price' data-id={window.article?.id} data-type={window.article?.type || 1}>
                          <a
                            id={
                              !!v?.discountPrice
                                ? "ArticleKindsLinkToAskPriceDiscountPrice"
                                : "ArticleKindsLinkToAskPrice"
                            }
                            className={cx(styles["ask"], {
                              'pointer-events-none': !v.link
                            })}
                            target='_blank'
                            href={`/ask/price?b=${v.brandId}&k=${v.kindId}&source=${
                              !!v?.discountPrice ? "文章詳情頁-相關車款-領取優惠" : "文章詳情頁-相關車款-一鍵詢價"
                            }`}
                          >
                            {!!v?.discountPrice ? "領取優惠" : "一鍵詢價"}
                          </a>
                        </div>
                      </div>
                    )}

                    <div className='flex justify-center items-center'>
                      <a
                        id='ArticleKindsLinkToPhotoModelBalance'
                        href={`/photoModel-balance.html?k=${v.kindId}`}
                        target='_blank'
                        className={"text-[#666666] text-18 hover:text-[#666666]"}
                      >
                        規格配備
                      </a>
                      <i className='w-1 h-16 mx-8 bg-[#E8E8E8]' />
                      <a
                        id='ArticleKindsLinkToArticleList'
                        href={`/kind-information/${v.kindId}`}
                        target='_blank'
                        className={"text-[#666666] text-18 hover:text-[#666666]"}
                      >
                        編輯測評
                      </a>
                      <i className='w-1 h-16 mx-8 bg-[#E8E8E8]' />
                      <a
                        id='ArticleKindsLinkToRatingList'
                        href={`/kind-comment/${v.kindId}`}
                        target='_blank'
                        className={"text-[#666666] text-18 hover:text-[#666666]"}
                      >
                        車友評價
                      </a>
                    </div>
                  </div>

                  <a
                    id={`ArticleKindsMenusToSummary`}
                    href={
                      !!v.menuCount
                        ? `/buy-car/menu?brandId=${v.brandId}&kindId=${v.kindId}`
                        : `/photoModel-info.html?k=${v.kindId}`
                    }
                    target='_blank'
                    style={{ background: "linear-gradient(90deg,#f2f7fe 5%, #d6e6fd)" }}
                    className='w-[278px] h-40 flex items-center justify-between text-[#666666] hover:text-[#666666] text-14 px-14 rounded-bl-4 rounded-br-4'
                  >
                    {!!v.menuCount
                      ? `${formatNumberToUnitString(Number(v.menuCount) || 0, {
                          needToLocalStringLessTenThousand: true,
                          digist: 1,
                        })}位車主分享成交行情`
                      : v.visitsRank}
                    <span className='text-[#3264FF] '> {!!v.visitsRank ? "查看" : "查看更多"}</span>
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    </Affix>
  );
};

const $relevantKinds = document.getElementById("acticle-new-relevant-kinds");
!!$relevantKinds && ReactDOM.render(<RelevantKinds />, $relevantKinds);
